import { gql } from '@apollo/client';
export const GET_AI_SUMMARY = gql `
  query GET_AI_SUMMARY($spec: AiSummarySpec!) {
    getAiSummary(spec: $spec) {
      total
      page
      pageSize
      items {
        id
        clientId
        userId
        s3Key
        documentEntity
        documentEntityId
        documentType
        llmRequestId
        llmResponse
        llmResponseDurationSec
      }
    }
  }
`;
export const TRIGGER_AI_PROCESSOR = gql `
  mutation TriggerAiProcessor($input: TriggerAiSummaryInput!) {
    triggerAiProcessor(input: $input)
  }
`;
export const GET_AI_SUMMARY_FEEDBACK = gql `
  query GetAiSummaryFeedback($spec: AiSummarySpec!) {
    getAiSummaryFeedback(spec: $spec) {
      total
      page
      pageSize
      items {
        id
        clientId
        userId
        llmRequestId
        llmResponse
        feedback
      }
    }
  }
`;
export const SAVE_AI_SUMMARY_FEEDBACK = gql `
  mutation SaveAiSummaryFeedback($input: AiSummaryFeedbackInput!) {
    saveAiSummaryFeedback(input: $input)
  }
`;
